
const Typography = () => {
    return {
        MuiTypography: {
            styleOverrides : {
                gutterBottom: {
                    marginBottom: 12
                }
            }
        }
    };
}

export default Typography;